module.exports = __webpack_public_path__ + "media/images/homes/Real-timeOrderChanges-308ffa7d4e6b3afe29d8bbcdece2c358.png";